import {IssueClosedIcon, IssueDraftIcon, IssueOpenedIcon} from '@primer/octicons-react'
import {ActionList, type ActionListItemProps, Truncate} from '@primer/react'

import type {AutocompleteIssue} from '../../utils/copilot-chat-types'

interface IssueSuggestionProps extends ActionListItemProps {
  issue: AutocompleteIssue
}

export function IssueSuggestion({issue, ...props}: IssueSuggestionProps) {
  return (
    <ActionList.Item {...props}>
      <ActionList.LeadingVisual>
        {issue.state === 'draft' && <IssueDraftIcon className="fgColor-neutral" />}
        {issue.state === 'open' && <IssueOpenedIcon className="fgColor-open" />}
        {issue.state === 'closed' && <IssueClosedIcon className="fgColor-done" />}
      </ActionList.LeadingVisual>
      <Truncate title={issue.title} maxWidth={350}>
        {issue.title}
      </Truncate>
      <ActionList.Description>#{issue.number}</ActionList.Description>
    </ActionList.Item>
  )
}

try{ IssueSuggestion.displayName ||= 'IssueSuggestion' } catch {}